"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _Disposable = _interopRequireDefault(require("../Disposable.js"));

var _functions = require("../functions.js");

var _util = require("../util.js");

var _transform = require("../transform.js");

var _extent = require("../extent.js");

var _IconImageCache = require("../style/IconImageCache.js");

var _Layer = require("../layer/Layer.js");

var _coordinate = require("../coordinate.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var __extends = void 0 && (void 0).__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");

    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
/**
 * @module ol/renderer/Map
 */


/**
 * @typedef HitMatch
 * @property {import("../Feature.js").FeatureLike} feature Feature.
 * @property {import("../layer/Layer.js").default} layer Layer.
 * @property {import("../geom/SimpleGeometry.js").default} geometry Geometry.
 * @property {number} distanceSq Squared distance.
 * @property {import("./vector.js").FeatureCallback<T>} callback Callback.
 * @template T
 */

/**
 * @abstract
 */
var MapRenderer =
/** @class */
function (_super) {
  __extends(MapRenderer, _super);
  /**
   * @param {import("../PluggableMap.js").default} map Map.
   */


  function MapRenderer(map) {
    var _this = _super.call(this) || this;
    /**
     * @private
     * @type {import("../PluggableMap.js").default}
     */


    _this.map_ = map;
    return _this;
  }
  /**
   * @abstract
   * @param {import("../render/EventType.js").default} type Event type.
   * @param {import("../PluggableMap.js").FrameState} frameState Frame state.
   */


  MapRenderer.prototype.dispatchRenderEvent = function (type, frameState) {
    (0, _util["abstract"])();
  };
  /**
   * @param {import("../PluggableMap.js").FrameState} frameState FrameState.
   * @protected
   */


  MapRenderer.prototype.calculateMatrices2D = function (frameState) {
    var viewState = frameState.viewState;
    var coordinateToPixelTransform = frameState.coordinateToPixelTransform;
    var pixelToCoordinateTransform = frameState.pixelToCoordinateTransform;
    (0, _transform.compose)(coordinateToPixelTransform, frameState.size[0] / 2, frameState.size[1] / 2, 1 / viewState.resolution, -1 / viewState.resolution, -viewState.rotation, -viewState.center[0], -viewState.center[1]);
    (0, _transform.makeInverse)(pixelToCoordinateTransform, coordinateToPixelTransform);
  };
  /**
   * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
   * @param {import("../PluggableMap.js").FrameState} frameState FrameState.
   * @param {number} hitTolerance Hit tolerance in pixels.
   * @param {boolean} checkWrapped Check for wrapped geometries.
   * @param {import("./vector.js").FeatureCallback<T>} callback Feature callback.
   * @param {S} thisArg Value to use as `this` when executing `callback`.
   * @param {function(this: U, import("../layer/Layer.js").default): boolean} layerFilter Layer filter
   *     function, only layers which are visible and for which this function
   *     returns `true` will be tested for features.  By default, all visible
   *     layers will be tested.
   * @param {U} thisArg2 Value to use as `this` when executing `layerFilter`.
   * @return {T|undefined} Callback result.
   * @template S,T,U
   */


  MapRenderer.prototype.forEachFeatureAtCoordinate = function (coordinate, frameState, hitTolerance, checkWrapped, callback, thisArg, layerFilter, thisArg2) {
    var result;
    var viewState = frameState.viewState;
    /**
     * @param {boolean} managed Managed layer.
     * @param {import("../Feature.js").FeatureLike} feature Feature.
     * @param {import("../layer/Layer.js").default} layer Layer.
     * @param {import("../geom/Geometry.js").default} geometry Geometry.
     * @return {T|undefined} Callback result.
     */

    function forEachFeatureAtCoordinate(managed, feature, layer, geometry) {
      return callback.call(thisArg, feature, managed ? layer : null, geometry);
    }

    var projection = viewState.projection;
    var translatedCoordinate = (0, _coordinate.wrapX)(coordinate.slice(), projection);
    var offsets = [[0, 0]];

    if (projection.canWrapX() && checkWrapped) {
      var projectionExtent = projection.getExtent();
      var worldWidth = (0, _extent.getWidth)(projectionExtent);
      offsets.push([-worldWidth, 0], [worldWidth, 0]);
    }

    var layerStates = frameState.layerStatesArray;
    var numLayers = layerStates.length;
    var matches =
    /** @type {Array<HitMatch<T>>} */
    [];
    var tmpCoord = [];

    for (var i = 0; i < offsets.length; i++) {
      for (var j = numLayers - 1; j >= 0; --j) {
        var layerState = layerStates[j];
        var layer = layerState.layer;

        if (layer.hasRenderer() && (0, _Layer.inView)(layerState, viewState) && layerFilter.call(thisArg2, layer)) {
          var layerRenderer = layer.getRenderer();
          var source = layer.getSource();

          if (layerRenderer && source) {
            var coordinates = source.getWrapX() ? translatedCoordinate : coordinate;
            var callback_1 = forEachFeatureAtCoordinate.bind(null, layerState.managed);
            tmpCoord[0] = coordinates[0] + offsets[i][0];
            tmpCoord[1] = coordinates[1] + offsets[i][1];
            result = layerRenderer.forEachFeatureAtCoordinate(tmpCoord, frameState, hitTolerance, callback_1, matches);
          }

          if (result) {
            return result;
          }
        }
      }
    }

    if (matches.length === 0) {
      return undefined;
    }

    var order = 1 / matches.length;
    matches.forEach(function (m, i) {
      return m.distanceSq += i * order;
    });
    matches.sort(function (a, b) {
      return a.distanceSq - b.distanceSq;
    });
    matches.some(function (m) {
      return result = m.callback(m.feature, m.layer, m.geometry);
    });
    return result;
  };
  /**
   * @abstract
   * @param {import("../pixel.js").Pixel} pixel Pixel.
   * @param {import("../PluggableMap.js").FrameState} frameState FrameState.
   * @param {number} hitTolerance Hit tolerance in pixels.
   * @param {function(import("../layer/Layer.js").default<import("../source/Source").default>, (Uint8ClampedArray|Uint8Array)): T} callback Layer
   *     callback.
   * @param {function(import("../layer/Layer.js").default<import("../source/Source").default>): boolean} layerFilter Layer filter
   *     function, only layers which are visible and for which this function
   *     returns `true` will be tested for features.  By default, all visible
   *     layers will be tested.
   * @return {T|undefined} Callback result.
   * @template T
   */


  MapRenderer.prototype.forEachLayerAtPixel = function (pixel, frameState, hitTolerance, callback, layerFilter) {
    return (0, _util["abstract"])();
  };
  /**
   * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
   * @param {import("../PluggableMap.js").FrameState} frameState FrameState.
   * @param {number} hitTolerance Hit tolerance in pixels.
   * @param {boolean} checkWrapped Check for wrapped geometries.
   * @param {function(this: U, import("../layer/Layer.js").default): boolean} layerFilter Layer filter
   *     function, only layers which are visible and for which this function
   *     returns `true` will be tested for features.  By default, all visible
   *     layers will be tested.
   * @param {U} thisArg Value to use as `this` when executing `layerFilter`.
   * @return {boolean} Is there a feature at the given coordinate?
   * @template U
   */


  MapRenderer.prototype.hasFeatureAtCoordinate = function (coordinate, frameState, hitTolerance, checkWrapped, layerFilter, thisArg) {
    var hasFeature = this.forEachFeatureAtCoordinate(coordinate, frameState, hitTolerance, checkWrapped, _functions.TRUE, this, layerFilter, thisArg);
    return hasFeature !== undefined;
  };
  /**
   * @return {import("../PluggableMap.js").default} Map.
   */


  MapRenderer.prototype.getMap = function () {
    return this.map_;
  };
  /**
   * Render.
   * @abstract
   * @param {?import("../PluggableMap.js").FrameState} frameState Frame state.
   */


  MapRenderer.prototype.renderFrame = function (frameState) {
    (0, _util["abstract"])();
  };
  /**
   * @param {import("../PluggableMap.js").FrameState} frameState Frame state.
   * @protected
   */


  MapRenderer.prototype.scheduleExpireIconCache = function (frameState) {
    if (_IconImageCache.shared.canExpireCache()) {
      frameState.postRenderFunctions.push(expireIconCache);
    }
  };

  return MapRenderer;
}(_Disposable["default"]);
/**
 * @param {import("../PluggableMap.js").default} map Map.
 * @param {import("../PluggableMap.js").FrameState} frameState Frame state.
 */


function expireIconCache(map, frameState) {
  _IconImageCache.shared.expire();
}

var _default = MapRenderer;
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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